import loadingGif from '../../../assets/img/loading.gif';
import React, { useState, useEffect, Fragment } from "react";
import axios from 'axios';
import AuthService from '../../../Auth/AuthService.js';
import { settings } from '../../../Helpers/Settings.js';
import { decodeToken, isExpired } from "react-jwt";
import { toast } from "react-toastify";
import Swal from 'sweetalert2';
import "react-toastify/dist/ReactToastify.css";
import moment from 'moment';
import DatePicker from "react-datepicker";

function GridOdeme({projeId, alisSatisMasrafKar}) {
    const [loading, setLoading] = useState(false);

    const [isTokenExpired, setIsTokenExpired] = useState(false);
    const [yetkiGor, setYetkiGor] = useState(/*null*/ true);
    const [yetkiEkle, setYetkiEkle] = useState(false);
    const [yetkiDegistir, setYetkiDegistir] = useState(false);
    const [yetkiSil, setYetkiSil] = useState(false);

    const [currentId, setCurrentId] = useState(0);

    const [projeMalzemeIdProjeMasrafIdInsert, setProjeMalzemeIdProjeMasrafIdInsert] = useState(0);
    const [odemeTuruIdInsert, setOdemeTuruIdInsert] = useState(0);
    const [odenenInsert, setOdenenInsert] = useState(0);
    const [kurInsert, setKurInsert] = useState(0);
    const [odemeTarihiInsert, setOdemeTarihiInsert] = useState(null);
    const [kapaliInsert, setKapaliInsert] = useState(false);

    const [projeMalzemeIdProjeMasrafIdUpdate, setProjeMalzemeIdProjeMasrafIdUpdate] = useState(0);
    const [odemeTuruIdUpdate, setOdemeTuruIdUpdate] = useState(0);
    const [odenenUpdate, setOdenenUpdate] = useState(0);
    const [kurUpdate, setKurUpdate] = useState(0);
    const [odemeTarihiUpdate, setOdemeTarihiUpdate] = useState(null);
    const [kapaliUpdate, setKapaliUpdate] = useState(false);

    const [data, setData] = useState([]);
    const [dataSum, setDataSum] = useState({});
    const [dataProjeMalzemeProjeMasraf, setDataProjeMalzemeProjeMasraf] = useState([]);
    const [dataOdemeTuru, setDataOdemeTuru] = useState([]);

    const days = ['Pz', 'Pt', 'Sa', 'Ça', 'Pe', 'Cu', 'Ct']
    const months = ['Ocak', 'Şubat', 'Mart', 'Nisan', 'Mayıs', 'Haziran', 'Temmuz', 'Ağustos', 'Eylül', 'Ekim', 'Kasım', 'Aralık']

    const datePickerLocale = {
      localize: {
        day: n => days[n],
        month: n => months[n]
      },
      formatLong: {
        date: () => 'dd.MM.yyyy'
      }
    }

    const tokenYenile = async () => {
        if (isExpired(localStorage.getItem('ATGroupToken')) === true) {
            setIsTokenExpired(true);

            return false;
        } else {
            const mail = decodeToken(localStorage.getItem('ATGroupToken'))["http://schemas.xmlsoap.org/ws/2005/05/identity/claims/emailaddress"];
            await AuthService.login(mail, localStorage.getItem('ATGroupToken'));
            return true;
        }
    }

    useEffect(() => {
        getAcilisData();
    }, []);

    useEffect(() => {
        if (yetkiGor === true) {
            getData();
        }
    }, [projeId]);

    const getAcilisData = async () => {
        if (tokenYenile() === false) {
            return;
        }

        //const apiurl = process.env.REACT_APP_API_URL;

        let tempYetkiGor = await AuthService.getYetkiKontrolByYetki("ERP - Projeler - Gör");

        setYetkiGor(tempYetkiGor);

        if (tempYetkiGor === true) {
            setYetkiEkle(await AuthService.getYetkiKontrolByYetki("ERP - Projeler - Ekle"));
            setYetkiDegistir(await AuthService.getYetkiKontrolByYetki("ERP - Projeler - Değiştir"));
            setYetkiSil(await AuthService.getYetkiKontrolByYetki("ERP - Projeler - Sil"));

            setDataProjeMalzemeProjeMasraf((await axios.get(settings.ApiUrl + "Lookup/GetProjeMalzemeProjeMasraf/" + projeId + "/" + alisSatisMasrafKar, { headers: AuthService.getHeaders() })).data.value);
            setDataOdemeTuru((await axios.get(settings.ApiUrl + "Lookup/GetOdemeTuru/" + alisSatisMasrafKar, { headers: AuthService.getHeaders() })).data.value);
        }
    }

    const getData = async () => {
        try {
            setLoading(true);

            const res = await axios.get(settings.ApiUrl + 'Proje/GetProjeOdemeList/' + projeId + "/" + alisSatisMasrafKar + "/0", { headers: AuthService.getHeaders() });

            const array = res.data.value;

            setData(array);

            let sumOdenen = 0;
            let sumOdenenTL = 0;

            for (let index = 0; index < array.length; index++) {
                let element = array[index];

                sumOdenen += element.odenen;
                sumOdenenTL += element.odenenTL;
            }

            setDataSum({
                "sumOdenen": sumOdenen,
                "sumOdenenTL": sumOdenenTL
            });
        } catch (error) {
            console.log(error);
        } finally {
            setLoading(false);
        }
    }

    const handleOdemeTarihiInsert = async (e) => {
        setOdemeTarihiInsert(e);
    }

    const handleOdemeTarihiUpdate = async (e) => {
        setOdemeTarihiUpdate(e);
    }

    const Degistir = async (id) => {
        if (tokenYenile() === false) {
            return;
        }

        try {
            const result = await axios.get(settings.ApiUrl + 'Proje/GetProjeOdemeList/0/' + alisSatisMasrafKar + "/" + id , { headers: AuthService.getHeaders() });

            if (result) {
                setCurrentId(id);
                setProjeMalzemeIdProjeMasrafIdUpdate(result.data.value[0].projeMalzemeIdProjeMasrafId);
                setOdemeTuruIdUpdate(result.data.value[0].odemeTuruId);
                setOdenenUpdate(result.data.value[0].odenen);
                setKurUpdate(result.data.value[0].kur);
                setOdemeTarihiUpdate(result.data.value[0].odemeTarihi);
            }
        } catch (error) {
            toast.error(error);
        }
    }

    const Sil = async (id) => {
        if (tokenYenile() === false) {
            return;
        }

        Swal.fire({
            title: "Uyarı",
            text: "Kayıt silinecek, emin misiniz?",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Sil",
            cancelButtonText: "Vazgeç"
        }).then(async (resultSwal) => {
            if (resultSwal.isConfirmed) {
                try {
                    const resultGet = await axios.get(settings.ApiUrl + 'Proje/GetProjeOdemeList/0/' + alisSatisMasrafKar + "/" + id, { headers: AuthService.getHeaders() });

                    if (resultGet) {
                        const resultDelete = await axios.post(settings.ApiUrl + 'Proje/DeleteProjeOdeme', [resultGet.data.value[0]], { headers: AuthService.getHeaders() });

                        if (resultDelete) {
                            if (resultDelete.data.success === true) {
                                await getData();
                                
                                toast.success("Silindi");
                            } else {
                                toast.error(resultDelete.data.message);
                            }
                        }
                    }
                } catch (error) {
                    toast.error(error);
                }
            }
        });
    }

    const Kaydet = async (kayitModu) => {
        if (tokenYenile() === false) {
            return;
        }
        
        let projeMalzemeIdProjeMasrafId = kayitModu === "insert" ? projeMalzemeIdProjeMasrafIdInsert : projeMalzemeIdProjeMasrafIdUpdate;
        let odemeTuruId = kayitModu === "insert" ? odemeTuruIdInsert : odemeTuruIdUpdate;
        let odenen = kayitModu === "insert" ? odenenInsert : odenenUpdate;
        let kur = kayitModu === "insert" ? kurInsert : kurUpdate;
        let odemeTarihi = kayitModu === "insert" ? odemeTarihiInsert : odemeTarihiUpdate;

        if (Number(projeMalzemeIdProjeMasrafId) === 0  || Number(odemeTuruId) === 0 || Number(odenen) === 0) {
            Swal.fire({ title: "Hata", text: "Lütfen ürün, para birimi ve miktar bilgilerini giriniz", icon: "error" });
        } else {
            try {
                const data = JSON.stringify({
                    "id": kayitModu === "insert" ? 0 : currentId,
                    "projeId": projeId,
                    "projeMalzemeIdProjeMasrafId": projeMalzemeIdProjeMasrafId,
                    "odemeTuruId": odemeTuruId,
                    "odenen": odenen,
                    "kur": kur,
                    "odemeTarihi": odemeTarihi ? moment(odemeTarihi).format('YYYY-MM-DD') : null,
                    "kapali" : Boolean(kayitModu === "insert" ? kapaliInsert : kapaliUpdate)
                });

                console.log(data);

                const result = await axios.post(settings.ApiUrl + 'Proje/InsertOrUpdateProjeOdeme/', data, { headers: AuthService.getHeaders() });

                if (result) {
                    if (result.data.success) {
                        setCurrentId(0);

                        if (kayitModu === "insert") {
                            setProjeMalzemeIdProjeMasrafIdInsert(0);
                            setOdemeTuruIdInsert(0);
                            setOdenenInsert(0);
                            setKurInsert(0);
                            setOdemeTarihiInsert(null);
                            setKapaliInsert(false);
                        }

                        await getData();

                        toast.success("Kaydedildi");
                    } else {
                        toast.error("Hata oluştu: " + result.data.message);
                    }
                }
            } catch (error) {
                toast.error("Hata oluştu:" + error);
            }
        }
    }

    const Vazgec = async () => {
        setCurrentId(0);
    }

    return (
        <Fragment>
            {
                isTokenExpired === true ?
                    <div className="alert alert-danger mb-1">
                        <button className="btn btn-link btn-sm" style={{color:"#58151c"}} onClick={() => AuthService.logout()}>Uzun süredir işlem yapmadığınız için oturumunuz sonlandırıldı. Lütfen tekrar giriş yapınız.</button>
                    </div>
                    :
                    yetkiGor !== null ?
                        yetkiGor === false ?
                            <div className="alert alert-danger">
                                Bu sayfaya erişim yetkiniz bulunmamaktadır
                            </div>
                            :
                            <React.Fragment>
                                {
                                    loading ?
                                        <div className="progressBackground">
                                            <div className="progressPopup">
                                            <img alt="Bekleyiniz..." src={loadingGif} />
                                            </div>
                                        </div>
                                        :
                                        ''
                                }
                                <div className="card">
                                    <div className="card-body mt-4">
                                        <div className="table-responsive">
                                            <table className="table table-bordered table-hover table-sm mb-0">
                                                <thead>
                                                    <tr>
                                                        <th style={{textAlign:"center", width:"38%"}}>Ödeme Konusu</th>
                                                        <th style={{textAlign:"center", width:"12%"}}>Ödeme Türü</th>
                                                        <th style={{textAlign:"center", width:"5%"}}>Para Birimi</th>
                                                        <th style={{textAlign:"center", width:"8%"}}>Ödenen Tutar</th>
                                                        <th style={{textAlign:"center", width:"8%"}}>Ödenen Tutar (TL)</th>
                                                        <th style={{textAlign:"center", width:"8%"}}>Kur</th>
                                                        <th style={{textAlign:"center", width:"8%"}}>Ödeme Tarihi</th>
                                                        <th style={{textAlign:"center", width:"8%"}}>Durumu</th>
                                                        <th style={{textAlign:"center", width:"5%"}}></th>
                                                    </tr>
                                                    <tr>
                                                        <th>
                                                            <select className="form-select form-select-sm" value={projeMalzemeIdProjeMasrafIdInsert} onChange={async (e) => setProjeMalzemeIdProjeMasrafIdInsert(e.target.value)}>
                                                                <option value={0}></option>
                                                                {
                                                                    dataProjeMalzemeProjeMasraf && dataProjeMalzemeProjeMasraf.length > 0 ?
                                                                    dataProjeMalzemeProjeMasraf.map((item, index) => {
                                                                        return (
                                                                            <option key={index} value={item.id}>{item.ad}</option>
                                                                        )
                                                                    })
                                                                    :
                                                                    null
                                                                }
                                                            </select>
                                                        </th>
                                                        <th>
                                                            <select className="form-select form-select-sm" value={odemeTuruIdInsert} onChange={async (e) => setOdemeTuruIdInsert(e.target.value)}>
                                                                <option value={0}></option>
                                                                {
                                                                    dataOdemeTuru && dataOdemeTuru.length > 0 ?
                                                                    dataOdemeTuru.map((item, index) => {
                                                                        return (
                                                                            <option key={index} value={item.id}>{item.ad}</option>
                                                                        )
                                                                    })
                                                                    :
                                                                    null
                                                                }
                                                            </select>
                                                        </th>
                                                        <th></th>
                                                        <th style={{textAlign:"right"}}>
                                                            <input type="number" className="form-control form-control-sm spinButtonWithoutButtons" style={{textAlign:"center"}} value={odenenInsert} onChange={(e) => setOdenenInsert(e.target.value)}></input>
                                                        </th>
                                                        <th></th>
                                                        <th style={{textAlign:"center"}}>
                                                            <input type="number" className="form-control form-control-sm spinButtonWithoutButtons" style={{textAlign:"center"}} value={kurInsert} onChange={(e) => setKurInsert(e.target.value)}></input>
                                                        </th>
                                                        <th style={{textAlign:"center"}}>
                                                            <DatePicker className="form-control form-control-sm text-center" calendarStartDay={1} todayButton="Bugün" locale={datePickerLocale} dateFormat="dd.MM.yyyy" selected={odemeTarihiInsert} onChange={async (e) => handleOdemeTarihiInsert(e)} />
                                                        </th>
                                                        <th style={{textAlign:"center"}}>
                                                            <select className="form-select form-select-sm" value={kapaliInsert} onChange={async (e) => setKapaliInsert(e.target.value)}>
                                                                <option value={false}>Açık</option>
                                                                <option value={true}>Kapalı</option>
                                                            </select>
                                                        </th>
                                                        <th style={{textAlign:"center"}}>
                                                            { yetkiEkle === true ? <button className="btn btn-sm btn-icon text-success" onClick={() => Kaydet("insert")}><i className="bi bi-plus-circle"></i></button> : '' }
                                                        </th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {
                                                        data && data.length > 0 ?
                                                            data.map((item, index) => {
                                                                return (
                                                                    <tr key={index}>
                                                                        <td>
                                                                            {
                                                                                currentId === item.id ?
                                                                                    <select className="form-select form-select-sm" value={projeMalzemeIdProjeMasrafIdUpdate} onChange={async (e) => setProjeMalzemeIdProjeMasrafIdUpdate(e.target.value)}>
                                                                                        <option value={0}></option>
                                                                                        {
                                                                                            dataProjeMalzemeProjeMasraf && dataProjeMalzemeProjeMasraf.length > 0 ?
                                                                                            dataProjeMalzemeProjeMasraf.map((item, index) => {
                                                                                                return (
                                                                                                    <option key={index} value={item.id}>{item.ad}</option>
                                                                                                )
                                                                                            })
                                                                                            :
                                                                                            null
                                                                                        }
                                                                                    </select>
                                                                                    :
                                                                                    item.projeMalzemeProjeMasraf
                                                                            }
                                                                        </td>
                                                                        <td style={{textAlign:"center"}}>
                                                                            {
                                                                                currentId === item.id ?
                                                                                    <select className="form-select form-select-sm" value={odemeTuruIdUpdate} onChange={async (e) => setOdemeTuruIdUpdate(e.target.value)}>
                                                                                        <option value={0}></option>
                                                                                        {
                                                                                            dataOdemeTuru && dataOdemeTuru.length > 0 ?
                                                                                            dataOdemeTuru.map((item, index) => {
                                                                                                return (
                                                                                                    <option key={index} value={item.id}>{item.ad}</option>
                                                                                                )
                                                                                            })
                                                                                            :
                                                                                            null
                                                                                        }
                                                                                    </select>
                                                                                    :
                                                                                    item.odemeTuru
                                                                            }
                                                                        </td>
                                                                        <td style={{textAlign:"center"}}>
                                                                            {item.paraBirimi}
                                                                        </td>
                                                                        <td style={{textAlign:"right"}}>
                                                                            {
                                                                                currentId === item.id ?
                                                                                    <input type="number" className="form-control form-control-sm spinButtonWithoutButtons" style={{textAlign:"center"}} value={odenenUpdate} onChange={(e) => setOdenenUpdate(e.target.value)}></input>
                                                                                    :
                                                                                    item.paraBirimi + item.odenen.toLocaleString('tr-TR', {minimumFractionDigits:2, maximumFractionDigits:2})
                                                                            }                                                                            
                                                                        </td>
                                                                        <td style={{textAlign:"right"}}>
                                                                            { "₺" + item.odenenTL.toLocaleString('tr-TR', {minimumFractionDigits:2, maximumFractionDigits:2})}
                                                                        </td>
                                                                        <td style={{textAlign:"center"}}>
                                                                            {
                                                                                currentId === item.id ?
                                                                                    <input type="number" className="form-control form-control-sm spinButtonWithoutButtons" style={{textAlign:"center"}} value={kurUpdate} onChange={(e) => setKurUpdate(e.target.value)}></input>
                                                                                    :
                                                                                    item.kur.toLocaleString('tr-TR', {minimumFractionDigits:4, maximumFractionDigits:4})
                                                                            }                                                                            
                                                                        </td>
                                                                        <td style={{textAlign:"center"}}>
                                                                            {
                                                                                currentId === item.id ?
                                                                                    <DatePicker className="form-control form-control-sm text-center" calendarStartDay={1} todayButton="Bugün" locale={datePickerLocale} dateFormat="dd.MM.yyyy" selected={odemeTarihiUpdate} onChange={async (e) => handleOdemeTarihiUpdate(e)} />
                                                                                    :
                                                                                    item.odemeTarihi ? moment(item.odemeTarihi).format('DD.MM.YYYY') : ""
                                                                            }                                                                            
                                                                        </td>
                                                                        <td style={{textAlign:"center"}}>
                                                                            {
                                                                                currentId === item.id ?
                                                                                    <select className="form-select form-select-sm" value={kapaliUpdate} onChange={async (e) => setKapaliUpdate(e.target.value)}>
                                                                                        <option value={false}>Açık</option>
                                                                                        <option value={true}>Kapalı</option>
                                                                                    </select>
                                                                                    :
                                                                                    <span className={item.kapali === true ? "badge bg-success" : "badge bg-primary"}>{item.durum}</span>
                                                                            }
                                                                        </td>
                                                                        <td align="center">
                                                                            {
                                                                                currentId === item.id ?
                                                                                    <div className="btn-group">
                                                                                        <button className="btn btn-sm btn-icon text-success" onClick={() => Kaydet("update")}><i className="bi bi-check-circle"></i></button>
                                                                                        <button className="btn btn-sm btn-icon text-danger" onClick={() => Vazgec()}><i className="bi bi-x-circle"></i></button>
                                                                                    </div>
                                                                                    :
                                                                                    <div className="btn-group">
                                                                                        { yetkiDegistir === true ? <button className="btn btn-sm btn-icon text-info" onClick={() => Degistir(item.id)}><i className="bi bi-pencil"></i></button> : '' }
                                                                                        { yetkiSil === true ? <button className="btn btn-sm btn-icon text-danger" onClick={() => Sil(item.id)}><i className="bi bi-trash3"></i></button> : '' }
                                                                                    </div>
                                                                            }
                                                                        </td>
                                                                    </tr>
                                                                )
                                                            })
                                                            :
                                                            <tr>
                                                                <td align="center" colSpan="9" style={{height:"48px"}}>
                                                                    Kayıt yok
                                                                </td>
                                                            </tr>
                                                    }
                                                </tbody>
                                                {
                                                    dataSum && dataSum.sumOdenen > 0 ?
                                                    <tfoot>
                                                        <tr>
                                                            <th colSpan={3} style={{textAlign:"center"}}>Toplam</th>
                                                            <th style={{textAlign:"right"}}>{dataSum.sumOdenen.toLocaleString('tr-TR', {minimumFractionDigits:2, maximumFractionDigits:2})}</th>
                                                            <th style={{textAlign:"right"}}>{dataSum.sumOdenenTL.toLocaleString('tr-TR', {minimumFractionDigits:2, maximumFractionDigits:2})}</th>
                                                            <th colSpan={3}></th>
                                                            <th></th>
                                                        </tr>                                                        
                                                    </tfoot>
                                                    :
                                                    null
                                                }
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </React.Fragment>
                        :
                        ""
            }
        </Fragment>
    );
};

export default GridOdeme;